export default __webpack_public_path__ + "static/media/4962.35d125e1.png";